"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseFetchedState = void 0;
var react_1 = require("react");
var abortController_1 = require("./abortController");
function createUseFetchedState(url, getDataFromResponse) {
    return function useFetchedState(defaultValueOrGetIt, dependencies, _a) {
        var _this = this;
        if (_a === void 0) { _a = {}; }
        var fetchOpts = _a.fetchOpts, _b = _a.shouldFetch, shouldFetch = _b === void 0 ? function () { return true; } : _b, _c = _a.onSuccess, onSuccess = _c === void 0 ? function () { } : _c, _d = _a.onError, onError = _d === void 0 ? function () { } : _d, _e = _a.onSetState, onSetState = _e === void 0 ? function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2];
        }); }); } : _e, rest = __rest(_a, ["fetchOpts", "shouldFetch", "onSuccess", "onError", "onSetState"]);
        var defaultValue = react_1.useRef(defaultValueOrGetIt instanceof Function ? defaultValueOrGetIt() : defaultValueOrGetIt);
        var _f = react_1.useState(defaultValue.current), state = _f[0], setState__internal = _f[1];
        var _g = react_1.useState(true), isLoading = _g[0], setIsLoading = _g[1];
        var setStateManual = react_1.useCallback(function (newStateOrFn) {
            setState__internal(function (currState) {
                var newState = newStateOrFn instanceof Function ? newStateOrFn(currState) : newStateOrFn;
                onSetState === null || onSetState === void 0 ? void 0 : onSetState({
                    prevState: currState,
                    newState: newState,
                    setState__internal: setState__internal,
                    setIsLoading: setIsLoading
                });
                return newState;
            });
        }, [setState__internal, onSetState, setIsLoading]);
        react_1.useEffect(function () {
            if (!(shouldFetch instanceof Function)) {
                throw new Error("shouldFetch must be a function, got " + typeof shouldFetch);
            }
            if (!shouldFetch({ setState__internal: setState__internal })) {
                console.info("not fetching");
                return;
            }
            var _a = abortController_1.abc(), signal = _a.signal, abort = _a.abort;
            var urlString;
            if (!(url instanceof Function)) {
                urlString = url;
            }
            else {
                var assertRestHasUrlCtx = function (r) {
                    if (!("urlCtx" in r)) {
                        throw new Error("url creator expects the urlCtx, but did not receive it");
                    }
                };
                assertRestHasUrlCtx(rest);
                urlString = url(rest.urlCtx);
            }
            var fetchArgs = [
                urlString,
                __assign({ signal: signal }, fetchOpts)
            ];
            var handleFetchErr = function (res) { if (!res.ok)
                throw new Error(res.statusText); return res; };
            var toJson = function (res) { return res.json(); };
            var setStateAndReturn = function (data) { setState__internal(data); return data; };
            var handleSucc = function (data) { return onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data, null); };
            var handleErr = function (e) {
                console.error(e);
                onError === null || onError === void 0 ? void 0 : onError(e, { defaultValue: defaultValue.current });
            };
            var setLoadingTrue = function () { return setIsLoading(true); };
            var setLoadingFalse = function () { return setIsLoading(false); };
            setLoadingTrue();
            fetch.apply(void 0, fetchArgs).then(handleFetchErr)
                .then(toJson)
                .then(getDataFromResponse)
                .then(setStateAndReturn)
                .then(handleSucc)
                .catch(handleErr)
                .finally(setLoadingFalse);
            return abort;
        }, dependencies);
        return [state, setStateManual, isLoading];
    };
}
exports.createUseFetchedState = createUseFetchedState;
exports.default = createUseFetchedState;
//# sourceMappingURL=useFetchedState.js.map